import { render } from "./IconTurnSharpLeftAlt.vue?vue&type=template&id=0f6a1dae"
import script from "./IconTurnSharpLeftAlt.vue?vue&type=script&lang=js"
export * from "./IconTurnSharpLeftAlt.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__